export default {
  getters: {
    categoryDescr: (state, getters, rootState) => cat => {
      let descr = "";
      if (cat != null) {
        descr = cat.descr;

        if (rootState.languageSelected != null) {
          let lang = rootState.languageSelected;
          if (lang.descrIndex == 1 && cat.descr1 != "") descr = cat.descr1;
          else if (lang.descrIndex == 2 && cat.descr2 != "") descr = cat.descr2;
        }
      }
      return descr;
    },

    itemDescr: (state, getters, rootState) => item => {
      let descr = "";
      if (item != null) {
        descr = item.descr;

        if (rootState.languageSelected != null) {
          let lang = rootState.languageSelected;
          if (lang.descrIndex == 1 && item.descr1 != "") descr = item.descr1;
          else if (lang.descrIndex == 2 && item.descr2 != "") descr = item.descr2;
        }
      }
      return descr;
    },

    categoryPosition: (state, getters, rootState) => {
      let position = "top";
      if (rootState.store != null && rootState.store.config != null && rootState.store.config.categoryPosition != null)
        position = rootState.store.config.categoryPosition;

      return position;
    },

    mainMenuEnabled: (state, getters, rootState) => {
      let enabled = false;
      if (rootState.store != null && rootState.store.config != null && rootState.store.config.mainMenuEnabled != null)
        enabled = rootState.store.config.mainMenuEnabled && getters.categoryPosition != "center";
      return enabled;
    },
  },
};
